import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { bindActionCreators } from 'redux'
import FontAwesome from 'react-fontawesome'
import TicketSaleSelectors from '../../../../ducks/ticket-sale/ticket-sale.selectors'
import { toastActions } from '../../../../actions'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import { breakpoints } from './../../../../constants/breakpoits.constants'
import TicketSaleService from './../../../../services/ticket-sale.service'
import { GREEN } from '../../../../styles/colors.style'
import { PRIMARY_COLOR, MEDIUMORANGE } from '../../../../styles/colors.style'
import { SkeletonSeatsCalculatedSelection } from '../skeletons'

class BusSeatSelectionModalResumeComponent extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		await TicketSaleService.getDiscountParameters().then(
			({ success, data }) => {
				if (success) {
					this.props.setFamilyDiscountParameters(data)
				}
			}
		)
	}

	render() {
		const {
			user,
			isBusSelectionReturnStep,
			toastSuccess,
			conexao,
			calculatedValues,
			familyDiscountApplied,
			isCalculatingValues,
		} = this.props

		const isPublicBody = user && user.hasPublicBody

		// Após a refatoração incluir hasFamilyDiscount no retorno descomentar o if abaixo.
		if (familyDiscountApplied) {
			toastSuccess({ message: 'O Desconto Família foi aplicado' })
		}

		const noTotal =
			calculatedValues.totalOrderValue == 0 &&
			calculatedValues.totalPointsUsed == 0

		const hasPlusSign =
			calculatedValues.totalOrderValue > 0 &&
			calculatedValues.totalPointsUsed > 0
				? ' + '
				: ''

		const msgServiceCharge =
			'Através desta taxa podemos prover tecnologia para você garantiar sua passagem de ônibus online e com antecedência: )'

		const showCohabitingMessage = false

		let isOnewayConnection = false
		let isReturnConnection = false

		if (conexao) {
			isOnewayConnection =
				conexao.conexaoIda && conexao.conexaoIda.trecho.length
			isReturnConnection =
				conexao.conexaoVolta && conexao.conexaoVolta.trecho.length
		}

		const groupedOnewayTrips = Object.entries(
			calculatedValues.ticketsGoing.reduce((prev, curr) => {
				prev[curr.tripDate]
					? prev[curr.tripDate].push(curr)
					: (prev[curr.tripDate] = [curr])
				return prev
			}, {})
		)

		const groupedReturnTrips = Object.entries(
			calculatedValues.ticketsReturn.reduce((prev, curr) => {
				prev[curr.tripDate]
					? prev[curr.tripDate].push(curr)
					: (prev[curr.tripDate] = [curr])
				return prev
			}, {})
		)

		return (
			<React.Fragment>
				{showCohabitingMessage && (
					<StyledWarningMessage>
						<span>
							<b>Sozinho, não compre assentos no corredor!</b> Eles são
							exclusivos para coabitantes dos assentos da janela ao lado.
						</span>
					</StyledWarningMessage>
				)}
				<span className={'title-color f-x-large'}>Suas poltronas</span>
				<br />
				<hr />

				{isCalculatingValues ? (
					<SkeletonSeatsCalculatedSelection />
				) : (
					<React.Fragment>
						<span className={'blue f-large'}>
							Viagem de ida
							<br />
						</span>

						{!calculatedValues.ticketsGoing.length ? (
							<StyledValue>Nenhuma poltrona selecionada.</StyledValue>
						) : null}

						{isOnewayConnection
							? groupedOnewayTrips.map(([key, value]) => {
									return (
										<div id={key}>
											<span className={'blue f-small'}>
												{value[0].originCity} {' > '}
												{value[0].destinationCity}
												<br />
											</span>
											{value.map(
												(
													{ fare, busSeat, bpePointsUsed },
													index
												) => (
													<StyledPrice
														key={index}
														number={busSeat}
														price={fare}
														points={bpePointsUsed}
													/>
												)
											)}
										</div>
									)
							  })
							: calculatedValues.ticketsGoing.map(
									({ fare, busSeat, bpePointsUsed }, index) => (
										<StyledPrice
											key={index}
											number={busSeat}
											price={fare}
											points={bpePointsUsed}
										/>
									)
							  )}

						{isBusSelectionReturnStep ? (
							<React.Fragment>
								<br />
								<span className={'blue f-large'}>
									Viagem de volta
									<br />
								</span>
								{!calculatedValues.ticketsReturn.length ? (
									<StyledValue>
										Nenhuma poltrona selecionada.
									</StyledValue>
								) : null}

								{isReturnConnection
									? groupedReturnTrips.map(([key, value]) => {
											return (
												<div id={key}>
													<span className={'blue f-small'}>
														{value[0].originCity} {' > '}
														{value[0].destinationCity}
														<br />
													</span>
													{value.map(
														(
															{ fare, busSeat, bpePointsUsed },
															index
														) => (
															<StyledPrice
																key={index}
																number={busSeat}
																price={fare}
																points={bpePointsUsed}
															/>
														)
													)}
												</div>
											)
									  })
									: calculatedValues.ticketsReturn.map(
											({ fare, busSeat, bpePointsUsed }, index) => (
												<StyledPrice
													key={index}
													number={busSeat}
													price={fare}
													points={bpePointsUsed}
												/>
											)
									  )}
							</React.Fragment>
						) : null}
						<hr />
						<StyledValueMin>
							<div>Subtotal</div>
							<div>
								{noTotal ? <span>{(0).$toReais()}</span> : null}
								{!!calculatedValues.totalPointsBpe ? (
									<span>
										{calculatedValues.totalPointsBpe.toLocaleString(
											'pt-BR'
										)}{' '}
										pts
									</span>
								) : null}
								{hasPlusSign}
								{!!calculatedValues.totalOrderValue ? (
									<span>{calculatedValues.totalFare.$toReais()}</span>
								) : null}
							</div>
						</StyledValueMin>

						{!isPublicBody && !!calculatedValues.totalFeeSummary && (
							<StyledValueMin>
								<div>Taxas, Impostos e Pedágios</div>
								<div>
									<span>
										{calculatedValues.totalFeeSummary.$toReais()}
									</span>
								</div>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalInsuranceValue && (
							<StyledValueMin>
								<div>Seguro</div>
								<div>
									<span>
										{calculatedValues.totalInsuranceValue.$toReais()}
									</span>
								</div>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalConvenienceFee && (
							<StyledValueMin>
								<div>
									Taxa de Serviço{' '}
									<FontAwesome
										name="info-circle"
										data-for="servicecharge-tooltip"
										data-tip="true"
										data-multiline="true"
										data-html="true"
									/>
								</div>
								<div>
									<span>
										{calculatedValues.totalConvenienceFee.$toReais()}
									</span>
								</div>
								<ReactTooltip
									id="servicecharge-tooltip"
									aria-haspopup="true"
									effect="solid"
									place="bottom">
									{msgServiceCharge}
								</ReactTooltip>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalPointsForConvenienceFee && (
							<StyledValueMin>
								<div>
									Taxa de Serviço{' '}
									<FontAwesome
										name="info-circle"
										data-for="servicecharge-tooltip"
										data-tip="true"
										data-multiline="true"
										data-html="true"></FontAwesome>
								</div>
								<div>
									<span>
										{calculatedValues.totalPointsForConvenienceFee}{' '}
										pts
									</span>
								</div>
								<ReactTooltip
									id="servicecharge-tooltip"
									aria-haspopup="true"
									effect="solid"
									place="bottom">
									{msgServiceCharge}
								</ReactTooltip>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalDiscount && (
							<StyledValueMin>
								<div style={{ color: GREEN }}>Descontos</div>
								<div style={{ color: GREEN }}>
									{
										<span>
											-{calculatedValues.totalDiscount.$toReais()}
										</span>
									}
								</div>
							</StyledValueMin>
						)}

						<hr />

						<StyledValueMin>
							<div style={{ fontWeight: 'bold' }}>Total</div>
							<div style={{ fontWeight: 'bold' }}>
								{noTotal ? <span>{(0).$toReais()}</span> : null}
								{!!calculatedValues.totalPointsUsed ? (
									<span>
										{calculatedValues.totalPointsUsed.toLocaleString(
											'pt-BR'
										)}{' '}
										pts
									</span>
								) : null}
								{hasPlusSign}
								{!!calculatedValues.totalOrderValue ? (
									<span>
										{calculatedValues.totalOrderValue.$toReais()}
									</span>
								) : null}
							</div>
						</StyledValueMin>
					</React.Fragment>
				)}
			</React.Fragment>
		)
	}
}

const StyledPrice = ({ number, price, bpePointsUsed }) => {
	return (
		<StyledValue>
			<div id={`seat-reserved-${number}`}>Poltrona {number}</div>
			<div>
				{bpePointsUsed > 0 ? (
					<span>{bpePointsUsed.toLocaleString('pt-BR')} pts</span>
				) : null}
				{price > 0 && bpePointsUsed > 0 ? ' + ' : ''}
				{price > 0 ? <span>{price.$toReais()}</span> : null}
			</div>
		</StyledValue>
	)
}

const StyledValue = styled.div`
	display: flex;
	font-size: x-large;
	justify-content: space-between;
	margin: 5px 0px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: initial;
		margin-left: 30px;
		margin-top: 10px;
	}
`

const StyledValueMin = styled.div`
	display: flex;
	font-size: x-large;
	justify-content: space-between;
	margin: 1px 0px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: initial;
		margin-left: 30px;
		margin-top: 0px;
		margin-bottom: 0px;
	}
`
const StyledWarningMessage = styled.div`
	background: linear-gradient(${PRIMARY_COLOR}, ${MEDIUMORANGE});
	border-radius: 5px;
	box-shadow: 0px 0px 7px 1px black;
	color: white;
	padding: 10px;
	margin-bottom: 20px;
	line-height: 22px;
`

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			setFamilyDiscountParameters:
				TicketSaleCreators.setFamilyDiscountParameters,
			setFamilyDiscountApplied: TicketSaleCreators.setFamilyDiscountApplied,
		},
		dispatch
	)
const mapStateToProps = (store) => ({
	user: store.user,

	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	isBusSelectionReturnStep:
		TicketSaleSelectors.isBusSelectionReturnStep(store),
	conexao: store.conexao,
	familyDiscountParameters:
		TicketSaleSelectors.getFamilyDiscountParameters(store),
	familyDiscountAllowed: store.ticketSale.familyDiscountAllowed,
	familyDiscountApplied: store.ticketSale.familyDiscountApplied,
	isCalculatingValues: store.ticketSale.isCalculatingValues,
})

export const BusSeatSelectionModalResume = connect(
	mapStateToProps,
	mapDispatchToProps
)(BusSeatSelectionModalResumeComponent)

export default BusSeatSelectionModalResume
